import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError';
import { PatientsApi } from '../../../apis/PatientsApi/PatientsApi';

export function useUpdateSexMutation(patientId?: string) {
    if (!patientId)
        throw new Error('useUpdateSexMutation requires a valid patientId');

    const queryClient = useQueryClient();

    return useMutation<boolean, AppMedError, number, unknown>({
        mutationKey: [QueryKeys.patientProfileSummary, patientId, 'sex'],
        mutationFn: async (sexID: number) => {
            return await PatientsApi.updateSex(parseInt(patientId, 10), sexID);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.patientProfileSummary, patientId] });
        },
    });
}
